import { initializeApp } from "firebase/app";
import { GoogleAuthProvider } from "firebase/auth";
import { getAuth } from "firebase/auth";
import 'firebase/firestore';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD1oi_DhuDbGfLSfLrfwk3sJvSeQnlRyhM",
  authDomain: "commuter-4294d.firebaseapp.com",
  projectId: "commuter-4294d",
  storageBucket: "commuter-4294d.appspot.com",
  messagingSenderId: "643606739470",
  appId: "1:643606739470:web:f206fb83e8ef66ec785a5f",
  measurementId: "G-8Q8T2W1VZY"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();
const db = getFirestore(app)

export { auth, googleAuthProvider, db };
export default app;
